import {Routes} from '@angular/router';
import {MobileMenuComponent} from '@odp/shared/lib/mobile-menu/mobile-menu.component';
import {COVID19_VARIANT_ROUTES} from './covid19-variant.routes';

export const COVID19_ROUTES: Routes = [
  {
    path: '',
    redirectTo: '/home',
    pathMatch: 'full'
  },
  {
    path: 'highlights',
    component: MobileMenuComponent,
    children: [
      {
        path: '',
        loadComponent: () => import('./features/highlights/highlights.component').then((m) => m.HighlightsComponent)
      }
    ]
  },
  {
    path: 'about',
    component: MobileMenuComponent,
    children: [
      {
        path: '',
        loadComponent: () => import('./features/about/about.component').then((m) => m.AboutComponent)
      }
    ]
  },
  {
    path: 'curveclasses',
    loadChildren: () =>
      import('./lazy-routes/screening-data/curve-classes.routes').then((m) => m.CurveClassesRouteModule)
  },
  {
    path: 'databrowser',
    loadChildren: () => import('./lazy-routes/screening-data/data-browser.routes').then((m) => m.DataBrowserRouteModule)
  },
  {
    path: 'GS-441524',
    loadChildren: () => import('./lazy-routes/screening-data/gs441524.routes').then((m) => m.GS441524RouteModule)
  },
  {
    path: 'assays',
    loadChildren: () => import('./lazy-routes/assay-details.routes').then((m) => m.AssayDetailsRouteModule)
  },
  {
    path: 'animal-models',
    loadChildren: () => import('./lazy-routes/animal-models.routes').then((m) => m.AnimalModelsRouteModule)
  },
  {
    path: 'therapeutic-glossary',
    loadChildren: () =>
      import('./lazy-routes/therapeutic-glossary.routes').then((m) => m.TherapeuticGlossaryRouteModule)
  },
  {
    path: 'variant',
    children: COVID19_VARIANT_ROUTES
  }
];
